import React from 'react';
import { Text, TEXT_VIEW } from "../Text";
import { STACK_GAP, StackView } from "../StackView";
import { Icon } from "../Icon";
import { useGridContext } from "../Grid/features";
export var textWrapId = 'grid-text-wrap';
var iconTextCellRenderer = function (_a) {
    var cellData = _a.cellData, columnWidth = _a.columnWidth, icon = _a.rowData.icon;
    var disabled = useGridContext().state.disabled;
    if (cellData && columnWidth) {
        return (React.createElement(StackView, { gap: STACK_GAP.s, "data-selector-id": textWrapId, style: {
                width: '100%',
                maxWidth: columnWidth + 50 + "px"
            } },
            icon && React.createElement(Icon, { disabled: disabled, src: icon }),
            React.createElement(Text, { view: disabled ? TEXT_VIEW.light : TEXT_VIEW.primary, truncate: true }, cellData)));
    }
    return null;
};
export default iconTextCellRenderer;
//# sourceMappingURL=iconTextCellRenderer.js.map